import { Switch } from '@mui/material';
import React from 'react';
import type { Control } from 'react-hook-form';
import { Controller } from 'react-hook-form';

type SeparateInvoiceSwitchProps = {
  control: Control
  fieldPath: string;
};

export const SeparateInvoiceSwitch: React.FC<SeparateInvoiceSwitchProps> = ({ control, fieldPath: controllerName }) => {
  return (
    <>
      <Controller
        control={control}
        name={controllerName}
        render={({ field }) => (
          <Switch
            checked={field.value}
            {...field}
          />
        )}
      />
      <label>Issue as separate invoice</label>
    </>
  );
};